/**
 * Cell suppression banner — intentionally a no-op for internal analytics.
 *
 * The platform previously enforced a k-anonymity threshold (n>=100) on
 * demographic breakdowns. For internal analysis across our own corporate
 * entity (legacy + current Trust data) we don't gate cells, so this
 * component renders nothing. The export is kept so existing imports
 * across the codebase don't need to change.
 */

import React from 'react';

interface Props {
  threshold?: number;
  className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const CellSuppressionBanner: React.FC<Props> = (_props) => null;
